export const formatDateWithTimezoneOffset = (isoDate: string|Date, offset = 0): string => {
  // Convert the ISO date string back to a Date object
  const date = new Date(isoDate);

  // Apply the timezone offset
  const utcDate = new Date(date.getTime() + offset * 60 * 60 * 1000);

  // Return the adjusted date in ISO format without the time component
  return utcDate.toISOString().split('T')[0];
};

export const getCurrentDate = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};



export const getMonthBoundaries = (
  startDate?: string | Date | null,
  endDate?: string | Date | null,
) => {
  // If startDate and endDate are provided, convert them to ISO format
  if (startDate && endDate) {
    const start = new Date(startDate).toISOString();
    const end = new Date(endDate).toISOString();
    return { firstDayIso: start, lastDayIso: end };
  }

  // Default to current month boundaries if no startDate or endDate
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth();
  const firstDay = new Date(Date.UTC(year, month, 1));
  const firstDayIso = firstDay.toISOString();
  const lastDay = new Date(Date.UTC(year, month + 1, 0));
  const lastDayIso = lastDay.toISOString();

  return { firstDayIso, lastDayIso };
};
